var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIOpenWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5983 9.36299V11.8828C13.5983 12.8315 12.8276 13.6022 11.8789 13.6022H4.11785C3.16921 13.6022 2.39844 12.8315 2.39844 11.8828V4.12175C2.39844 3.17311 3.16921 2.40234 4.11785 2.40234H6.63767",
    stroke: "#A2A6AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5988 6.32141V2.40234H9.67969",
    stroke: "#A2A6AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.597 2.40234L8 8.00525",
    stroke: "#A2A6AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOpenWindow);
export default __webpack_public_path__ + "static/media/i_open_window.1ee08cee0febe164cb4c1ef2a059d8f7.svg";
export { ForwardRef as ReactComponent };